/**
 * Resolves the Mongo ObjectId string for the club a CLUB_MANAGER manages.
 * Handles common API shapes: flat ids, nested club / managedClub objects, and JWT payloads.
 */
export function pickManagedClubIdFromUser(user) {
  if (!user || typeof user !== "object") return null;
  const firstClubFromList =
    Array.isArray(user.clubs) && user.clubs.length
      ? typeof user.clubs[0] === "object" && user.clubs[0] !== null
        ? user.clubs[0]._id ?? user.clubs[0].id
        : user.clubs[0]
      : null;

  const v =
    user.managedClubId ??
    user.managedclub ??
    user.managed_club_id ??
    user.clubId ??
    user.clubid ??
    user.club_id ??
    (typeof user.club === "object" && user.club !== null
      ? user.club._id ?? user.club.id
      : user.club) ??
    (typeof user.managedClub === "object" && user.managedClub !== null
      ? user.managedClub._id ?? user.managedClub.id
      : user.managedClub) ??
    firstClubFromList;
  if (v == null || v === "") return null;
  if (typeof v === "object") {
    if (v._id != null) return String(v._id);
    if (v.id != null) return String(v.id);
    return null;
  }
  return String(v);
}

/**
 * @param {object} decoded - jwtDecode result
 */
export function pickManagedClubIdFromJwtPayload(decoded) {
  if (!decoded || typeof decoded !== "object") return null;
  const flat =
    decoded.managedclub ??
    decoded.managedClub ??
    decoded.managed_club_id ??
    decoded.club_id ??
    decoded.ManagedClubId;
  if (flat != null && flat !== "") {
    if (typeof flat === "object" && flat._id) return String(flat._id);
    return String(flat);
  }
  const direct =
    pickManagedClubIdFromUser(decoded) ??
    pickManagedClubIdFromUser(decoded.user) ??
    pickManagedClubIdFromUser(decoded.payload);
  if (direct) return direct;

  const nestedKeys = [
    "managedClub",
    "club",
    "clubRef",
    "clubDocument",
  ];
  for (const k of nestedKeys) {
    const n = decoded[k];
    if (n && typeof n === "object" && (n._id || n.id)) {
      return String(n._id ?? n.id);
    }
  }
  return null;
}
